/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  AuthorRecommendationsControllerCreateMutationRequest,
  AuthorRecommendationsControllerCreateMutationResponse,
  AuthorRecommendationsControllerCreate400,
  AuthorRecommendationsControllerCreate401,
  AuthorRecommendationsControllerCreate429,
} from '../../types/AuthorRecommendationsControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { authorRecommendationsCreate } from '../../methods/authorRecommendationsCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const authorRecommendationsCreateMutationKey = () => [{ url: '/api/author-recommendations' }] as const;

export type AuthorRecommendationsCreateMutationKey = ReturnType<typeof authorRecommendationsCreateMutationKey>;

/**
 * {@link /api/author-recommendations}
 */
export function useAuthorRecommendationsCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      AuthorRecommendationsControllerCreateMutationResponse,
      ResponseErrorConfig<
        | AuthorRecommendationsControllerCreate400
        | AuthorRecommendationsControllerCreate401
        | AuthorRecommendationsControllerCreate429
      >,
      { data: AuthorRecommendationsControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<AuthorRecommendationsControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? authorRecommendationsCreateMutationKey();

  return useMutation<
    AuthorRecommendationsControllerCreateMutationResponse,
    ResponseErrorConfig<
      | AuthorRecommendationsControllerCreate400
      | AuthorRecommendationsControllerCreate401
      | AuthorRecommendationsControllerCreate429
    >,
    { data: AuthorRecommendationsControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return authorRecommendationsCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
